export default __webpack_public_path__ + "static/media/imgMaiorClube3.006121ba.png";